export default __webpack_public_path__ + "static/media/nor.6d3f8f93.svg";